import { InputEdit } from "components";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "utils/hooks";

import { COLORS } from "../../utils/colors";

import "./SelectTenant.css";

import { jwtDecode } from "jwt-decode";

export function SelectTenant() {
  const {
    onTenant,
    onLogout,
    general_access_token,
    isUserAuthorized,
  } = useAuth();

  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [tenantId, setTenantId] = useState("");
  const [errorMessage, setError] = useState("");

  const [decoded, setDecode] = useState();
  useEffect(() => {
    if (general_access_token) {
      setDecode(jwtDecode(general_access_token));
    }
  }, [general_access_token]);

  useEffect(() => {
    if (isUserAuthorized) {
      navigate("/overview/dashboard");
    }
  }, [isUserAuthorized]);

  return (
    <div className="classy-subtle-dark-gray-gradient">
      <Container>
        <Container className="d-flex align-items-center justify-content-center vh-100 login-container login-component-grow">
          <Col xs={10} md={10} lg={6}>
            <Form className="shadow  login-form" style={{ opacity: 0.9 }}>
              <h5 style={{ color: "#dbdbdb" }}>Select a company</h5>
              <Form.Group
                style={{
                  opacity: 0.9,
                  maxHeight: "400px", // or any height you want
                  overflowY: "auto", // enables vertical scrolling
                }}
              >
                {decoded?.tenants.map((tenant) => (
                  <Card
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                    key={tenant.tenantId}
                    className="p-2 mb-2 card-tenant"
                    onClick={async (e) => {
                      e.preventDefault();

                      const result = await onTenant(tenant.tenantId);
                      if (!result) {
                        setError("Cannot access tenant");
                        return;
                      } else {
                        navigate("/overview/dashboard");
                      }
                    }}
                    // style={{ backgroundColor: "white", borderRadius:30, borderColor:"red"}}
                  >
                    <span
                      className="text-lg font-semibold"
                      style={{ color: COLORS.greyFontColor }}
                    >
                      <strong style={{ color: "#177ddc" }}>
                        Company name:
                      </strong>{" "}
                      {tenant.tenantName}
                    </span>
                    <span
                      className="text-lg font-semibold"
                      style={{ color: COLORS.greyFontColor }}
                    >
                      <strong style={{ color: "#177ddc" }}>Tenant ID:</strong>{" "}
                      {tenant.tenantId}
                    </span>

                    <span
                      className="text-sm text-gray-600"
                      style={{ color: COLORS.greyFontColor }}
                    >
                      <strong style={{ color: COLORS.selectedColorTheme }}>Role:</strong>{" "}
                      {tenant.tenantRole}
                    </span>
                  </Card>
                ))}
              </Form.Group>
              <Form.Group className="text-center">
                <Button
                  type="submit"
                  lg={8}
                  className="btn btn-danger mt-3"
                  onClick={async (e) => {
                    e.preventDefault();

                    const result = await onLogout();
                    navigate("/login");
                  }}
                >
                  Logout
                </Button>
              </Form.Group>
            </Form>
          </Col>
        </Container>
      </Container>
    </div>
  );
}
